"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setBubbleChartUiConfig = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var uiConfig_1 = require("../../constants/uiConfig");
var bucket_1 = require("../../constants/bucket");
var bucketHelper_1 = require("./../bucketHelper");
var bucket_title_measures_x_svg_1 = tslib_1.__importDefault(require("../../assets/bubble/bucket-title-measures-x.svg"));
var bucket_title_measures_y_svg_1 = tslib_1.__importDefault(require("../../assets/bubble/bucket-title-measures-y.svg"));
var bucket_title_size_svg_1 = tslib_1.__importDefault(require("../../assets/bubble/bucket-title-size.svg"));
var bucket_title_view_by_svg_1 = tslib_1.__importDefault(require("../../assets/bubble/bucket-title-view-by.svg"));
function setBubbleChartUiConfig(referencePoint, intl, visualizationType) {
    var referencePointConfigured = cloneDeep_1.default(referencePoint);
    set_1.default(referencePointConfigured, uiConfig_1.UICONFIG, bucketHelper_1.setBucketTitles(referencePoint, visualizationType, intl));
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.MEASURES, "icon"], bucket_title_measures_x_svg_1.default);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.SECONDARY_MEASURES, "icon"], bucket_title_measures_y_svg_1.default);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.TERTIARY_MEASURES, "icon"], bucket_title_size_svg_1.default);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.VIEW, "icon"], bucket_title_view_by_svg_1.default);
    return referencePointConfigured;
}
exports.setBubbleChartUiConfig = setBubbleChartUiConfig;
//# sourceMappingURL=bubbleChartUiConfigHelper.js.map